import Vue from 'vue';
import Vuex from 'vuex';

// Modulos
import user from './user';
import layout from './layout';
import administraciones from './administraciones';
import metadata from './metadata';
import endpoints from './endpoints';
//import propuestas_libres from './propuestas-libres'; (Oculto temporalmente para evitar que se exponga)

import { isDevMode } from '../app.consts';

Vue.use(Vuex);

export default new Vuex.Store({

  modules: {
    user,
    layout,
    administraciones,
    metadata,
    endpoints
    //propuestas_libres (Oculto temporalmente para evitar que se exponga)
  },

  strict: isDevMode(),
});





